module.exports = __webpack_public_path__ + "static/media/supplier_info.6e70ee5c.png";